const sendGTMEvent = (eventName, eventParams = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...eventParams
    });
  };
  
  export default sendGTMEvent;